export const DEFAULT_MARKETPLACE_TAX_PERCENT = 4

// The tax is only charged when selling on the marketplace, never when buying.
export function applyMarketplaceTax(revenue: number, taxPercent: number): number {
    return revenue * (1 - taxPercent / 100)
}
